import { FlashProduct } from "./Flash";

export interface FlashCoupon {
	Code: string;
	CodeFormatted: string;
	FlashProduct: FlashProduct;
	Amount: number;
	DateCreatedUtc: string;
	CreatedByUserId: string;
	Redeemed: boolean;
	RedeemedDateUtc: string;
	RedeemedUserId: string;
}


export class CreateFlashCouponModel {
	ProductCode: number;
	Amount: number;
}

export class EditFlashCouponModel extends CreateFlashCouponModel {
	Code: string;
	constructor(item?: FlashCoupon) {
		super();
		this.Code = item && item.Code;
		this.ProductCode = item && item.FlashProduct.ProductCode;
		this.Amount = item && item.Amount;
		this.Code = item && item.Code;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/flashcoupon.ts